import React from "react";
import ErrorIcon from "@mui/icons-material/Error";
import { Snackbar } from "@mui/material";

import withStyles from '@mui/styles/withStyles';

const styles = (theme) => ({
  root: {
    marginTop: 24,
  },
  message: {
    display: "flex",
    alignItems: "center",
  },
  errorIcon: {
    marginRight: theme?.spacing ? theme.spacing(1) : "8px",
  },
  error: {
    backgroundColor: "#d32f2f",
  },
  success: {
    backgroundColor: "#e3f2fd",
  },
});

const NotificationBar = ({ classes, errorMessage, successMessage='' }) => {
  return (
    <Snackbar
      className={classes.root}
      ContentProps={{
        classes: {
          root: successMessage ? classes.success : classes.error,
        },
      }}
      anchorOrigin={{ horizontal: "center", vertical: "top" }}
      open={true}
      message={
        <span className={classes.message}>
          <ErrorIcon className={classes.errorIcon} />
          {successMessage || errorMessage}
        </span>
      }
    />
  );
};

export default withStyles(styles)(NotificationBar);
